const NON_CACHEABLE_ROUTES_REGEX = ['^/a/'];

export { NON_CACHEABLE_ROUTES_REGEX };
